import type { FC } from "react";
import { lazy, Suspense } from "react";

import { isDevelopment } from "@shared/utils";

const HotReloadIndicator = lazy(() => import("./HotReloadIndicator"));

const LazyHotReloadIndicator: FC = () => {
  if (!isDevelopment()) return null;

  return (
    <Suspense fallback={null}>
      <HotReloadIndicator />
    </Suspense>
  );
};

export { LazyHotReloadIndicator };
